import axios from "axios";

export const AD_REQUEST = "AD_REQUEST";
export const AD_ERROR = "AD_ERROR";
export const FETCH_ADS_SUCCESS = "FETCH_ADS_SUCCESS";
export const CREATE_AD_SUCCESS = "CREATE_AD_SUCCESS";
export const UPDATE_AD_SUCCESS = "UPDATE_AD_SUCCESS";
export const DELETE_AD_SUCCESS = "DELETE_AD_SUCCESS";

// GET
export const fetchAds = () => async (dispatch) => {
    dispatch({ type: AD_REQUEST });
    try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/ads/get-ads`);
        dispatch({ type: FETCH_ADS_SUCCESS, payload: res.data.data });
    } catch (error) {
        dispatch({ type: AD_ERROR, payload: error.message });
    }
};

// POST
export const createAd = (formData) => async (dispatch) => {
    dispatch({ type: AD_REQUEST });
    try {
        const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/ads/create-ads`, formData);
        dispatch({ type: CREATE_AD_SUCCESS, payload: res.data.data });
        return res.data;
    } catch (error) {
        dispatch({ type: AD_ERROR, payload: error.message });
        throw error;
    }
};

// PUT
export const updateAd = (id, formData) => async (dispatch) => {
    dispatch({ type: AD_REQUEST });
    try {
        const res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/ads/update-ad/${id}`, formData);
        dispatch({ type: UPDATE_AD_SUCCESS, payload: res.data.data });
        return res.data;
    } catch (error) {
        dispatch({ type: AD_ERROR, payload: error.message });
        throw error;
    }
};

// DELETE
export const deleteAd = (id) => async (dispatch) => {
    dispatch({ type: AD_REQUEST });
    try {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/ads/delete-ad/${id}`);
        dispatch({ type: DELETE_AD_SUCCESS, payload: id });
    } catch (error) {
        dispatch({ type: AD_ERROR, payload: error.message });
    }
};

